import 'jquery-countdown'

window['portal/attachment_relations#index'] = function () {
  $(document).on('shown.bs.tooltip', '.destroy-tooltip', function (e) {
    const time = $(e.target).data('time')
    $('.countdown').countdown(time).on('update.countdown', function (event) { $(this).html(event.strftime('%H:%M:%S')) })
  })
}
